export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const SOVREN_ACCOUNT_ID = '';
export const SOVREN_SERVICE_KEY = '';

export const SOVREN_PARSER_BASE_URL = '';
export const CV_PARSING = '';
